<template>
  <div style="width: 100%;height: 100%">
    <div class="title"><span>物联态势</span></div>
    <div class="content">
      <el-row style="height: 100%">
        <el-col :span="16" style="height: 100%">
          <div style="width: calc(100% - 20px);height: 100%;margin-right: 20px">
            <alarm-statistic></alarm-statistic>
          </div>
        </el-col>
        <el-col :span="8" style="height: 100%">
          <div style="height: 50%;width: 100%">
            <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="alarmBar" ref="alarmWrap"></div>
          </div>
          <div style="height: 50%;width: 100%">
            <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="deviceBar" ref="deviceWrap"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import alarmStatistic from './alarmStatistic'
import * as echarts from 'echarts'
import {querydataviewdevicecount} from '../../../api/home'
export default {
  name: 'iotSituation',
  components: {alarmStatistic},
  data () {
    return {
      alarmChart: null,
      alarmXData: [],
      alarmYData: [],

      deviceChart: null,
      deviceData: []
    }
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    if (this.alarmChart) {
      this.alarmChart.dispose()
      this.alarmChart = null
    }
    if (this.deviceChart) {
      this.deviceChart.dispose()
      this.deviceChart = null
    }
  },
  methods: {
    getStartData (obj) {
      this.getAlarmChartData(obj.sevendayalarmtype)
      this.getDeviceChartData(obj)
    },

    getAlarmChart () {
      if (!this.alarmChart) {
        this.alarmChart = this.$echarts.init(this.$refs.alarmWrap)
      }
      let option = {
        tooltip: {},
        legend: {
          textStyle: {
            color: '#fff'
          }
        },
        grid: {top: '20%', left: '3%', right: '4%', bottom: '3%', containLabel: true},
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#7fd4ff',
              width: 1
            }
          },
          splitLine: {
            show: false
          },
          data: this.alarmXData
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#fff'
            }
          }
        ],
        series: [
          {
            name: '报警趋势',
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              color: '#fff'
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 1, 0, 0,
                  [
                    {offset: 0, color: 'rgba(0, 103, 220, 0)'},
                    {offset: 1, color: 'rgba(0, 227, 192, 1)'}
                    // {offset: 0, color: '#0067dc'},
                    // {offset: 1, color: '#00e3c0'}
                  ]
                ),
                borderColor: new echarts.graphic.LinearGradient(
                  0, 1, 0, 0,
                  [
                    {offset: 0, color: 'rgba(3, 23, 31, 0)'},
                    {offset: 1, color: 'rgba(0, 235, 177, 1)'}
                    // {offset: 0, color: '#03171f'},
                    // {offset: 1, color: '#00ebb1'}
                  ]
                ),
                borderWidth: 1
              }
            },
            data: this.alarmYData
          }
        ]
      }
      this.alarmChart.setOption(option)
    },
    getAlarmChartData (sevenAlarmArr) {
      let xData = []
      let yData = []
      let now = new Date()
      now.setDate(now.getDate() - 8)
      for (let i = 0; i < 7; i++) {
        now.setDate(now.getDate() + 1)
        let date = now.format('yyyy-MM-dd')
        xData.push(date)
        let arr = sevenAlarmArr.filter(r => r.alarmdate === date)
        let count = 0
        if (arr && arr.length !== 0) {
          arr.forEach(item => {
            count += parseInt(item.alarmcount)
          })
        }
        yData.push(count)
      }
      setTimeout(() => {
        this.alarmXData = xData
        this.alarmYData = yData
        this.getAlarmChart()
      }, 200)
    },

    getDeviceChart () {
      if (!this.householdChart) {
        this.deviceChart = this.$echarts.init(this.$refs.deviceWrap)
      }
      let option = {
        tooltip: {
          trigger: 'item'
        },
        // grid: {top: '5%', left: '10%', right: '0%', bottom: '10%', containLabel: true},
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            // center: ['50%', '50%'],
            data: this.deviceData,
            // roseType: 'radius',
            label: {
              show: true,
              formatter: '{name|{b}}\n\n{percent|{d}%}',
              rich: {
                name: {color: '#bac3c4'},
                percent: {color: 'auto'}
              }
            }
          }
        ]
      }
      this.deviceChart.setOption(option)
    },
    getDeviceChartData () {
      this.deviceData = []
      querydataviewdevicecount().then(res => {
        let data = res.data.dataviewdevicecount
        let deviceTypeCount = data.DeviceTypeCount
        deviceTypeCount.forEach(item => {
          let value = parseInt(item.devicecount)
          let name = ''
          name = this.commonType.getDeviceType(parseInt(item.devicetype))
          if (parseInt(item.devicetype) === 700) {
            name = '智能网关'
          }
          this.deviceData.push({name: name, value: value})
        })
        this.getDeviceChart()
      })
    },

    chartResize () {
      this.alarmChart.resize()
      this.deviceChart.resize()
    }
  }
}
</script>

<style scoped>
  .title {
    padding-left: 55px;
    height: 32px;
    width: calc(100% - 55px);
    background: url("../../../assets/dataScreen/title2.png") no-repeat;
    background-size: 100% 100%;
    color: #ffffff;
    font-size: 15px;
    line-height: 32px;
  }
  .content {
    height: calc(100% - 42px);
    width: calc(100% - 20px);
    padding: 10px 10px 0;
    background-image: linear-gradient(
      #0b182c,
      #0b182c),
    linear-gradient(
      #03171f,
      #03171f);
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreenComponents/iotSituation.vue